module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bird@2x_b73c85.png";